<router-outlet (activate)="onActivate(true)"></router-outlet>

<eid-dev-tools class="theme-switcher" *ngIf="showDevTools === true"></eid-dev-tools>
